import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // AUTHENTICATION DISABLED FOR TESTING - Don't redirect on 401 errors
      // if (error && error.status === 401) {
      //   router.navigateByUrl('/');
      // }
      return throwError(() => error);
    })
  );
};
